// import React, { useState, forwardRef, useCallback, useEffect, useRef } from "react";
// import AppIcon from "../../../components/ui/AppIcon";
// import { useAuth } from "../../../context/AuthContext";
// import HighlightedText from '../../../components/HighlightedText';
// import ReactionTrigger from './ReactionTrigger';
// import ReactionPopover from './ReactionPopover';

// const MessageBubble = forwardRef(function MessageBubble(
//     {
//         message,
//         isOwn,
//         onReaction,
//         hideAvatar,
//         hideSenderName,
//         highlight = false,
//         highlightQuery = null,
//     },
//     ref
// ) {
//     const { user } = useAuth();
//     const containerRef = useRef(null);

//     // Local hover and popover state (simple, controlled within component)
//     const [isHovered, setIsHovered] = useState(false);
//     const [isPopoverOpen, setIsPopoverOpen] = useState(false);

//     // Helper: Convert emoji code (number or numeric string) to emoji character
//     const getEmoji = (reaction) => {
//         const emojiVal = reaction?.emoji;
//         if (typeof emojiVal === 'number') {
//             return String.fromCodePoint(emojiVal);
//         }
//         if (typeof emojiVal === 'string' && /^\d+$/.test(emojiVal)) {
//             return String.fromCodePoint(parseInt(emojiVal, 10));
//         }
//         return emojiVal;
//     };

//     // Merge forwarded ref with internal container ref
//     const mergedRef = useCallback((node) => {
//         if (typeof ref === 'function') {
//             ref(node);
//         } else if (ref) {
//             ref.current = node;
//         }
//         containerRef.current = node;
//     }, [ref]);

//     // ── Resolve sender name ───────────────────────────────────────────────────
//     // Aggregation returns message.sender as { _id, name, username, profilePhoto }
//     // Socket messages may still use flat fields as fallback
//     const getSenderName = () => {
//         // 1. Check senderInfo.name (from normalizer/pipeline)
//         if (message.senderInfo?.name) {
//             return message.senderInfo.name;
//         }
//         // 2. Check sender as object
//         if (message.sender && typeof message.sender === "object") {
//             if (message.sender.name) return message.sender.name;
//             if (message.sender.username) return message.sender.username;
//             if (message.sender.displayName) return message.sender.displayName;
//         }
//         // 3. Check flat senderName
//         if (message.senderName) return message.senderName;
//         // 4. Check sender as string
//         if (typeof message.sender === "string") return message.sender;
//         return "Unknown";
//     };

//     // ── Resolve sender avatar ─────────────────────────────────────────────────
//     const getSenderAvatar = () => {
//         const name = getSenderName();
//         if (message.sender && typeof message.sender === "object") {
//             return message.sender.profilePhoto || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
//         }
//         if (message.senderAvatar) return message.senderAvatar;
//         if (message.profilePhoto) return message.profilePhoto;
//         return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
//     };

//     // ── Resolve sender ID for "isOwn" check ──────────────────────────────────
//     const getSenderId = () => {
//         if (message.senderId) return message.senderId.toString();
//         if (message.senderInfo?._id) return message.senderInfo._id.toString();
//         if (message.sender && typeof message.sender === "object") {
//             return message.sender._id?.toString();
//         }
//         if (message.sender) return message.sender.toString();
//         return null;
//     };

//     // ── Determine if this message is from the logged-in user ─────────────────
//     const isOwnMessage = isOwn ||
//         getSenderId() === (user?._id || user?.id)?.toString() ||
//         getSenderName() === user?.name;

//     // ── Format timestamp ──────────────────────────────────────────────────────
//     const formatTime = (ts) => {
//         if (!ts) return "";
//         try {
//             return new Date(ts).toLocaleTimeString([], {
//                 hour: "2-digit",
//                 minute: "2-digit",
//             });
//         } catch (e) {
//             return "";
//         }
//     };

//     const senderName = getSenderName();
//     const senderAvatar = getSenderAvatar();
//     const messageId = message._id || message.id;
//     const content = message.text || message.message || message.content || "";
//     const timestamp = message.timestamp || message.createdAt;

//     // ── Helper: Get file icon based on extension ────────────────────────────────────
//     const getFileIcon = (filename) => {
//         const ext = filename.split('.').pop()?.toLowerCase();
//         const iconMap = {
//             pdf: 'DocumentIcon',
//             doc: 'DocumentTextIcon',
//             docx: 'DocumentTextIcon',
//             xls: 'TableCellsIcon',
//             xlsx: 'TableCellsIcon',
//             zip: 'ArchiveBoxIcon',
//             rar: 'ArchiveBoxIcon',
//             jpg: 'PhotoIcon',
//             jpeg: 'PhotoIcon',
//             png: 'PhotoIcon',
//             gif: 'PhotoIcon',
//             webp: 'PhotoIcon',
//             mp4: 'VideoCameraIcon',
//             mov: 'VideoCameraIcon',
//             webm: 'VideoCameraIcon',
//             mp3: 'MusicalNoteIcon',
//             default: 'DocumentIcon'
//         };
//         return iconMap[ext] || iconMap.default;
//     };

//     // ── Render message content based on type ───────────────────────────────────────
//     const renderMessageContent = () => {
//         const content = message.text || message.message || message.content || "";

//         // File/Image/Video messages (type: "url")
//         if (message.type === "url" || message.type === "file" || message.type === "image") {
//             const imageRegex = /\.(jpg|jpeg|png|gif|webp|svg)$/i;
//             const videoRegex = /\.(mp4|webm|ogg|mov)$/i;

//             if (imageRegex.test(content)) {
//                 return (
//                     <div className="mt-3 rounded-2xl overflow-hidden border border-white/10 max-w-sm group/img">
//                         <img
//                             src={content}
//                             alt="uploaded image"
//                             className="w-full h-auto max-h-[300px] object-cover cursor-zoom-in transition-transform duration-500 group-hover/img:scale-105"
//                             onClick={() => window.open(content, '_blank')}
//                         />
//                     </div>
//                 );
//             }

//             if (videoRegex.test(content)) {
//                 return (
//                     <div className="mt-3 rounded-2xl overflow-hidden border border-white/10 max-w-sm bg-black">
//                         <video controls className="w-full h-auto max-h-[300px]">
//                             <source src={content} />
//                         </video>
//                     </div>
//                 );
//             }

//             // Generic file attachment
//             const fileName = content.split('/').pop() || 'File';
//             return (
//                 <div
//                     onClick={() => window.open(content, '_blank')}
//                     className="flex flex-col gap-2 mt-3 bg-[var(--bg-surface)] p-3 rounded-xl border border-white/5"
//                 >
//                     <div className="flex items-center gap-4 bg-white/5 border border-white/5 p-3.5 rounded-2xl max-w-sm hover:bg-white/10 transition-all cursor-pointer group/file">
//                         <div className="w-10 h-10 rounded-xl bg-indigo-500/20 flex items-center justify-center text-indigo-400 group-hover/file:bg-indigo-500 group-hover/file:text-white transition-all">
//                             <AppIcon name={getFileIcon(fileName)} size={20} />
//                         </div>
//                         <div className="flex-1 min-w-0">
//                             <p className="text-sm font-bold text-white truncate">{fileName}</p>
//                             <p className="text-[11px] text-[var(--text-muted)] font-medium uppercase tracking-wider">
//                                 {fileName.split('.').pop()?.toUpperCase() || 'FILE'}
//                             </p>
//                         </div>
//                         <AppIcon name="ArrowDownTrayIcon" size={16} className="text-[var(--text-muted)] opacity-0 group-hover/file:opacity-100 transition-opacity" />
//                     </div>
//                 </div>
//             );
//         }

//         // Code blocks
//         if (message.type === "code") {
//             const lines = content.split("\n");
//             return (
//                 <div className="mt-3 rounded-xl overflow-hidden border border-white/5 bg-[#08080C]/80 font-mono text-[13px] leading-relaxed group/code shadow-2xl transition-all hover:bg-black">
//                     <div className="flex items-center justify-between px-4 py-2 bg-white/5 border-b border-white/5">
//                         <div className="flex items-center gap-1.5 opacity-40">
//                             <AppIcon name="CommandLineIcon" size={12} />
//                             <span className="text-[10px] uppercase font-bold tracking-widest">{message.language || "code"}</span>
//                         </div>
//                         <button
//                             onClick={() => navigator.clipboard?.writeText(content)}
//                             className="text-[10px] font-bold text-indigo-400 hover:text-white transition-colors opacity-0 group-hover/code:opacity-100"
//                         >
//                             COPY
//                         </button>
//                     </div>
//                     <div className="p-4 overflow-x-auto custom-scrollbar">
//                         {lines.map((line, i) => (
//                             <div key={i} className="flex gap-4">
//                                 <span className="opacity-20 select-none w-4 text-right">{i + 1}</span>
//                                 <HighlightedText
//                                     text={line}
//                                     highlightQuery={highlightQuery}
//                                     className="text-indigo-200 whitespace-pre [&_mark]:bg-indigo-500/30 [&_mark]:text-white [&_mark]:px-1 [&_mark]:rounded"
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         // Plain text
//         return (
//             <HighlightedText
//                 text={content}
//                 highlightQuery={highlightQuery}
//                 className="text-[15px] leading-relaxed text-[#F0EFFF]/90 whitespace-pre-wrap [&_mark]:bg-indigo-500/30 [&_mark]:text-white [&_mark]:px-1 [&_mark]:rounded"
//             />
//         );
//     };

//     // Handlers
//     const handleTriggerClick = useCallback((e) => {
//         e.stopPropagation();
//         setIsPopoverOpen(prev => !prev);
//     }, []);

//     const handleReaction = useCallback((emoji) => {
//         if (messageId) {
//             onReaction?.(messageId, emoji);
//         }
//         setIsPopoverOpen(false);
//     }, [messageId, onReaction]);

//     const handlePin = useCallback(() => {
//         if (messageId) {
//             onReaction?.(messageId, "pin");
//         }
//         setIsPopoverOpen(false);
//     }, [messageId, onReaction]);

//     const handleDelete = useCallback(() => {
//         if (messageId) {
//             onReaction?.(messageId, "delete");
//         }
//         setIsPopoverOpen(false);
//     }, [messageId, onReaction]);

//     const closePopover = useCallback(() => {
//         setIsPopoverOpen(false);
//     }, []);

//     // ── Mobile long-press support ───────────────────────────────────────────
//     const longPressTimer = useRef(null);
//     const LONG_PRESS_DURATION = 500; // ms

//     const handleTouchStart = useCallback((e) => {
//         // Ignore if touching interactive elements (buttons, links, inputs)
//         const target = e.target;
//         if (!target) return;
//         const tag = target.tagName?.toLowerCase();
//         if (tag && ['button', 'a', 'input', 'textarea', 'select', 'video'].includes(tag)) {
//             return;
//         }
//         // Start long-press timer
//         longPressTimer.current = setTimeout(() => {
//             setIsPopoverOpen(true);
//             // Haptic feedback if available
//             if (navigator.vibrate) {
//                 navigator.vibrate(50);
//             }
//         }, LONG_PRESS_DURATION);
//     }, []);

//     const handleTouchEnd = useCallback(() => {
//         if (longPressTimer.current) {
//             clearTimeout(longPressTimer.current);
//             longPressTimer.current = null;
//         }
//     }, []);

//     const handleTouchCancel = useCallback(() => {
//         if (longPressTimer.current) {
//             clearTimeout(longPressTimer.current);
//             longPressTimer.current = null;
//         }
//     }, []);

//     // Cleanup timer on unmount
//     useEffect(() => {
//         return () => {
//             if (longPressTimer.current) {
//                 clearTimeout(longPressTimer.current);
//             }
//         };
//     }, []);

//     // ── Close popover when clicking outside ───────────────────────────────────
//     useEffect(() => {
//         if (!isPopoverOpen) return;

//         const handleClickOutside = (e) => {
//             if (containerRef.current && !containerRef.current.contains(e.target)) {
//                 closePopover();
//             }
//         };

//         const handleEscape = (e) => {
//             if (e.key === 'Escape') {
//                 closePopover();
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         document.addEventListener('touchstart', handleClickOutside);
//         document.addEventListener('keydown', handleEscape);

//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//             document.removeEventListener('touchstart', handleClickOutside);
//             document.removeEventListener('keydown', handleEscape);
//         };
//     }, [isPopoverOpen, closePopover]);

//     return (
//         <div
//             ref={mergedRef}
//             data-message-id={messageId}
//             className={`
//                 flex gap-3 group relative
//                 ${isOwnMessage ? "flex-row-reverse" : "flex-row"}
//                 ${hideAvatar ? "mt-0.5" : "mt-4"}
//                 ${highlight ? 'ring-2 ring-indigo-400 ring-offset-2 ring-offset-[#0F0F1A] animate-pulse' : ''}
//             `}
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//             onTouchStart={handleTouchStart}
//             onTouchEnd={handleTouchEnd}
//             onTouchCancel={handleTouchCancel}
//         >
//             {/* ── Avatar ─────────────────────────────────────────────────────── */}
//             <div className="flex-shrink-0 w-9">
//                 {!hideAvatar ? (
//                     <img
//                         src={senderAvatar}
//                         alt={senderName}
//                         className="w-9 h-9 rounded-xl object-cover border border-white/10 shadow-lg"
//                     />
//                 ) : (
//                     <div className="w-9" />
//                 )}
//             </div>

//             {/* ── Message content ────────────────────────────────────────────── */}
//             <div className={`flex flex-col max-w-[70%] min-w-0 ${isOwnMessage ? "items-end" : "items-start"}`}>

//                 {/* Sender name + timestamp — only shown on first message in group */}
//                 {!hideSenderName && !hideAvatar && (
//                     <div className={`flex items-baseline gap-2 mb-1 ${isOwnMessage ? "flex-row-reverse" : "flex-row"}`}>
//                         <span className="text-[12px] font-bold text-white/90 truncate">
//                             {isOwnMessage ? "You" : senderName}
//                         </span>
//                         <span className="text-[10px] text-[var(--text-muted)] flex-shrink-0">
//                             {formatTime(timestamp)}
//                         </span>
//                     </div>
//                 )}

//                 {/* Bubble container with position: relative for popover */}
//                 <div
//                     className={`
//                         relative
//                         px-4 py-2.5
//                         rounded-2xl
//                         text-sm leading-relaxed break-words
//                         ${isOwnMessage
//                             ? "bg-indigo-500 text-white rounded-tr-sm"
//                             : "bg-[var(--bg-surface)] text-white/90 rounded-tl-sm border border-white/5"
//                         }
//                         ${hideAvatar ? (isOwnMessage ? "rounded-tr-2xl" : "rounded-tl-2xl") : ""}
//                         ${isPopoverOpen ? 'z-50' : ''}
//                     `}
//                 >
//                     {renderMessageContent()}

//                     {/* Timestamp inside bubble for grouped messages */}
//                     {hideAvatar && (
//                         <span className={`text-[9px] ml-2 opacity-50 flex-shrink-0 ${isOwnMessage ? "text-white/70" : "text-[var(--text-muted)]"}`}>
//                             {formatTime(timestamp)}
//                         </span>
//                     )}

//                     {/* Reaction trigger button (top-right corner) */}
//                     {messageId && (
//                         <div
//                             className="
//                                 absolute
//                                 top-2 right-2
//                                 z-20
//                             "
//                         >
//                             <ReactionTrigger
//                                 onClick={handleTriggerClick}
//                                 isVisible={isHovered && !isPopoverOpen}
//                             />
//                         </div>
//                     )}

//                     {/* Reaction popover */}
//                     {isPopoverOpen && (
//                         <ReactionPopover
//                             messageId={messageId}
//                             onReaction={handleReaction}
//                             onPin={handlePin}
//                             onDelete={handleDelete}
//                             isOwn={isOwnMessage}
//                             isVisible={isPopoverOpen}
//                             onClose={closePopover}
//                         />
//                     )}
//                 </div>

//                 {/* ── Existing Reactions ───────────────────────────────────────── */}
//                 {message.reactions && message.reactions.length > 0 && (
//                     <div className={`flex flex-wrap gap-1 mt-1 ${isOwnMessage ? "justify-end" : "justify-start"}`}>
//                         {message.reactions.map((reaction, idx) => (
//                             <span
//                                 key={idx}
//                                 className="text-xs bg-white/10 rounded-full px-2 py-0.5 cursor-pointer hover:bg-white/20 transition-colors"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     onReaction?.(messageId, reaction.emoji);
//                                 }}
//                             >
//                                 {getEmoji(reaction)} {reaction.count > 1 ? reaction.count : ""}
//                             </span>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// });

// export default React.memo(MessageBubble);

//====================

// FILE: src/features/chat/components/MessageBubble.jsx
// CHANGES:
//   1. Bubble div: added `overflow-visible` so the portal-based ReactionPopover
//      is not clipped. (Root cause #2 fix)
//   2. Pass `containerRef` as `anchorRef` to ReactionPopover so it can
//      compute its portal position relative to the bubble.
//   3. getEmoji() replaced with toEmojiChar() from messageNormalizer —
//      single source of truth for all emoji conversion.
//   4. Existing reaction chips also use toEmojiChar() for consistency.

import React, {
  useState,
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useMemo,
} from "react";
import AppIcon from "../../../components/ui/AppIcon";
import { useAuth } from "../../../context/AuthContext";
import HighlightedText from "../../../components/HighlightedText";
import MentionText from "../../../components/ui/MentionText";
import ReactionTrigger from "./ReactionTrigger";
import ReactionPopover from "./ReactionPopover";
import {
  toEmojiChar,
  normalizeReactions,
} from "../../../utils/messageNormalizer";

// ── WhatsApp-style message status tick component ──────────────────────────────
// sending → clock  sent → ✔ (gray)  delivered → ✔✔ (gray)  seen → ✔✔ (blue)
// Rules:
//   • Only rendered for own (sent) messages
//   • Smooth color transition — never flickers backward
//   • Pure SVG ticks — no emoji characters (consistent cross-platform)
function MessageStatusTick({ status }) {
  if (!status || status === "error") return null;

  if (status === "sending") {
    return (
      <span className="inline-flex items-center opacity-50" title="Sending">
        <svg className="w-3 h-3 text-current animate-spin" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" strokeDasharray="28" strokeDashoffset="10" strokeLinecap="round" />
        </svg>
      </span>
    );
  }

  // Single tick — sent (server confirmed)
  if (status === "sent") {
    return (
      <span className="inline-flex items-center opacity-60" title="Sent">
        <svg className="w-3.5 h-3" viewBox="0 0 14 10" fill="none">
          <path d="M1.5 5L5 8.5L12.5 1.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    );
  }

  // Double ticks — delivered (gray) or seen (blue)
  const isSeen = status === "seen";
  return (
    <span
      className={`inline-flex items-center transition-colors duration-300 ${isSeen ? "text-blue-400" : "opacity-60"}`}
      title={isSeen ? "Seen" : "Delivered"}
    >
      <svg className="w-[18px] h-3" viewBox="0 0 18 10" fill="none">
        {/* Back tick */}
        <path d="M1 5L4.5 8.5L12 1.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        {/* Front tick (offset right) */}
        <path d="M5.5 5L9 8.5L16.5 1.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}
// ─────────────────────────────────────────────────────────────────────────────

const MessageBubble = forwardRef(function MessageBubble(
  {
    message,
    isOwn,
    onReaction,
    hideAvatar,
    hideSenderName,
    highlight = false,
    highlightQuery = null,
    channelMemberCount = 0,
  },
  ref,
) {
  const { user } = useAuth();
  // containerRef is used BOTH as the forwarded ref target AND as the
  // anchor for ReactionPopover's portal positioning.
  const containerRef = useRef(null);
  const bubbleRef = useRef(null); // anchor for the popover

  const [isHovered, setIsHovered] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  const handleCopyCode = useCallback((text) => {
    const doCopy = () => {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        navigator.clipboard.writeText(text).then(() => {
          setCopiedCode(true);
          setTimeout(() => setCopiedCode(false), 2000);
        }).catch(() => {
          // Clipboard API failed — try execCommand fallback
          fallbackCopy(text);
        });
      } else {
        fallbackCopy(text);
      }
    };

    const fallbackCopy = (text) => {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        setCopiedCode(true);
        setTimeout(() => setCopiedCode(false), 2000);
      } catch (_) {
        // Both methods failed — silent fail
      }
    };

    doCopy();
  }, []);

  // Merge forwarded ref with internal containerRef
  const mergedRef = useCallback(
    (node) => {
      if (typeof ref === "function") ref(node);
      else if (ref) ref.current = node;
      containerRef.current = node;
    },
    [ref],
  );

  // ── Sender resolution ─────────────────────────────────────────────────────
  const getSenderName = () => {
    if (message.senderInfo?.name) return message.senderInfo.name;
    if (message.sender && typeof message.sender === "object") {
      if (message.sender.name) return message.sender.name;
      if (message.sender.username) return message.sender.username;
      if (message.sender.displayName) return message.sender.displayName;
    }
    if (message.senderName) return message.senderName;
    if (typeof message.sender === "string") return message.sender;
    return "Unknown";
  };

  const getSenderAvatar = () => {
    const name = getSenderName();
    if (message.senderInfo?.profilePhoto)
      return message.senderInfo.profilePhoto;
    if (message.sender && typeof message.sender === "object") {
      return (
        message.sender.profilePhoto ||
        `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`
      );
    }
    if (message.senderAvatar) return message.senderAvatar;
    if (message.profilePhoto) return message.profilePhoto;
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
  };
  
  const getSenderId = () => {
    if (message.senderId) return message.senderId.toString();
    if (message.senderInfo?._id) return message.senderInfo._id.toString();
    if (message.sender && typeof message.sender === "object")
      return message.sender._id?.toString();
    if (message.sender) return message.sender.toString();
    return null;
  };

  const isOwnMessage =
    isOwn ||
    getSenderId() === (user?._id || user?.id)?.toString() ||
    getSenderName() === user?.name;

  // ── Status derivation for Channels ─────────────────────────────────────────
  const derivedStatus = useMemo(() => {
    if (!isOwnMessage) return null;
    // For DMs, we rely on the flat status passed through normalization
    if (!message.deliveredTo && !message.seenBy) return message.status || "sent";
    
    // For Channels, we compare array lengths to member count
    const seenCount = (message.seenBy || []).length;
    const deliveredCount = (message.deliveredTo || []).length;
    
    // If everyone saw it
    if (seenCount >= channelMemberCount && channelMemberCount > 0) return 'seen';
    // If everyone got it
    if (deliveredCount >= channelMemberCount && channelMemberCount > 0) return 'delivered';
    
    return message.status || 'sent';
  }, [isOwnMessage, message.status, message.deliveredTo, message.seenBy, channelMemberCount]);

  // ── Formatting ────────────────────────────────────────────────────────────
  const formatTime = (ts) => {
    if (!ts) return "";
    try {
      return new Date(ts).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "";
    }
  };

  const senderName = getSenderName();
  const senderAvatar = getSenderAvatar();
  const messageId = message._id || message.id;
  const timestamp = message.timestamp || message.createdAt;

  // ── File icon helper ──────────────────────────────────────────────────────
  const getFileIcon = (filename) => {
    const ext = filename.split(".").pop()?.toLowerCase();
    const iconMap = {
      pdf: "DocumentIcon",
      doc: "DocumentTextIcon",
      docx: "DocumentTextIcon",
      xls: "TableCellsIcon",
      xlsx: "TableCellsIcon",
      zip: "ArchiveBoxIcon",
      rar: "ArchiveBoxIcon",
      jpg: "PhotoIcon",
      jpeg: "PhotoIcon",
      png: "PhotoIcon",
      gif: "PhotoIcon",
      webp: "PhotoIcon",
      mp4: "VideoCameraIcon",
      mov: "VideoCameraIcon",
      webm: "VideoCameraIcon",
      mp3: "MusicalNoteIcon",
      default: "DocumentIcon",
    };
    return iconMap[ext] || iconMap.default;
  };

  // ── Message content renderer ──────────────────────────────────────────────
  const renderMessageContent = () => {
    const content = message.text || message.message || message.content || "";

    if (
      message.type === "url" ||
      message.type === "file" ||
      message.type === "image"
    ) {
      const imageRegex = /\.(jpg|jpeg|png|gif|webp|svg)$/i;
      const videoRegex = /\.(mp4|webm|ogg|mov)$/i;

      if (imageRegex.test(content)) {
        return (
          <div className="mt-3 rounded-2xl overflow-hidden border border-white/10 max-w-sm group/img">
            <img
              src={content}
              alt="uploaded"
              className="w-full h-auto max-h-[300px] object-cover cursor-zoom-in transition-transform duration-500 group-hover/img:scale-105"
              onClick={() => window.open(content, "_blank")}
            />
          </div>
        );
      }

      if (videoRegex.test(content)) {
        return (
          <div className="mt-3 rounded-2xl overflow-hidden border border-white/10 max-w-sm bg-black">
            <video controls className="w-full h-auto max-h-[300px]">
              <source src={content} />
            </video>
          </div>
        );
      }

      const fileName = content.split("/").pop() || "File";
      return (
        <div
          onClick={() => window.open(content, "_blank")}
          className="flex flex-col gap-2 mt-3 bg-app-surface p-3 rounded-2xl border border-border-subtle shadow-subtle"
        >
          <div className="flex items-center gap-4 bg-app-bg/50 border border-border-subtle p-3.5 rounded-xl max-w-sm hover:border-primary/30 transition-all cursor-pointer group/file shadow-sm">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all">
              <AppIcon name={getFileIcon(fileName)} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-text-primary truncate">
                {fileName}
              </p>
              <p className="text-[10px] text-text-muted font-bold uppercase tracking-widest">
                {fileName.split(".").pop()?.toUpperCase() || "FILE"}
              </p>
            </div>
            <AppIcon
              name="ArrowDownTrayIcon"
              size={16}
              className="text-text-muted opacity-0 group-hover/file:opacity-100 transition-opacity"
            />
          </div>
        </div>
      );
    }

    if (message.type === "code") {
      const lines = content.split("\n");
      return (
        <div className="mt-3 rounded-xl overflow-hidden border border-border-subtle bg-app-bg font-mono text-[11px] sm:text-[12px] md:text-[13px] leading-relaxed group/code shadow-subtle transition-all">
          <div className="flex items-center justify-between px-3 md:px-4 py-2 bg-black/5 border-b border-border-subtle">
            <div className="flex items-center gap-1.5 opacity-60">
              <AppIcon name="CommandLineIcon" size={12} className="text-text-primary" />
              <span className="text-[9px] sm:text-[10px] uppercase font-bold tracking-widest text-text-primary">
                {message.language || "code"}
              </span>
            </div>
            <button
              onClick={() => handleCopyCode(content)}
              aria-label="Copy code to clipboard"
              className="text-[9px] sm:text-[10px] font-bold text-primary hover:text-primary-dark transition-colors"
            >
              {copiedCode ? "COPIED ✓" : "COPY"}
            </button>
          </div>
          <div className="p-2 sm:p-3 md:p-4">
            {lines.map((line, i) => (
              <div key={i} className="flex gap-2 md:gap-4 min-w-0">
                <span className="opacity-40 select-none flex-shrink-0 min-w-[1.5rem] sm:min-w-[2rem] md:min-w-[2.5rem] text-right text-text-muted font-mono tabular-nums">
                  {i + 1}
                </span>
                <HighlightedText
                  text={line}
                  highlightQuery={highlightQuery}
                  className="text-text-secondary whitespace-pre-wrap break-all [overflow-wrap:anywhere] min-w-0 [&_mark]:bg-primary/20 [&_mark]:text-primary [&_mark]:px-1 [&_mark]:rounded"
                />
              </div>
            ))}
          </div>
        </div>
      );
    }

    // Plain text — render with mention highlighting.
    // When a search query is active, fall back to HighlightedText so search
    // marks still work; otherwise use MentionText for @mention pills.
    if (highlightQuery?.trim()) {
      return (
        <HighlightedText
          text={content}
          highlightQuery={highlightQuery}
          className="text-[15px] leading-relaxed text-inherit whitespace-pre-wrap [&_mark]:bg-primary/20 [&_mark]:text-primary [&_mark]:px-1 [&_mark]:rounded"
        />
      );
    }

    return (
      <MentionText
        text={content}
        currentUser={user?.username || user?.name}
        className="text-[15px] leading-relaxed text-inherit whitespace-pre-wrap"
      />
    );
  };

  // ── Action handlers ───────────────────────────────────────────────────────
  const handleTriggerClick = useCallback((e) => {
    e.stopPropagation();
    setIsPopoverOpen((prev) => !prev);
  }, []);

  const handleReaction = useCallback(
    (emoji) => {
      if (messageId) onReaction?.(messageId, emoji);
      setIsPopoverOpen(false);
    },
    [messageId, onReaction],
  );

  const handlePin = useCallback(() => {
    if (messageId) onReaction?.(messageId, "pin");
    setIsPopoverOpen(false);
  }, [messageId, onReaction]);

  const handleDelete = useCallback(() => {
    if (messageId) onReaction?.(messageId, "delete");
    setIsPopoverOpen(false);
  }, [messageId, onReaction]);

  const closePopover = useCallback(() => setIsPopoverOpen(false), []);

  // ── Mobile long-press ─────────────────────────────────────────────────────
  const longPressTimer = useRef(null);

  const handleTouchStart = useCallback((e) => {
    const tag = e.target?.tagName?.toLowerCase();
    if (["button", "a", "input", "textarea", "select", "video"].includes(tag))
      return;
    longPressTimer.current = setTimeout(() => {
      setIsPopoverOpen(true);
      if (navigator.vibrate) navigator.vibrate(50);
    }, 500);
  }, []);

  const clearLongPress = useCallback(() => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  }, []);

  useEffect(() => () => clearLongPress(), [clearLongPress]);

  // ── Normalise reactions from message (safety net) ─────────────────────────
  const safeReactions = normalizeReactions(message.reactions ?? []);

  return (
    <div
      ref={mergedRef}
      data-message-id={messageId}
      className={`
        flex gap-3 group relative
        ${isOwnMessage ? "flex-row-reverse" : "flex-row"}
        ${hideAvatar ? "mt-1" : "mt-5"}
        ${highlight ? "ring-2 ring-primary ring-offset-2 ring-offset-app-bg animate-pulse" : ""}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={clearLongPress}
      onTouchCancel={clearLongPress}
    >
      {/* Avatar */}
      <div className="flex-shrink-0 w-9">
        {!hideAvatar ? (
          <img
            src={senderAvatar}
            alt={senderName}
            className="w-9 h-9 rounded-xl object-cover border border-border-subtle shadow-sm"
          />
        ) : (
          <div className="w-9" />
        )}
      </div>

      {/* Message content column */}
      <div
        className={`flex flex-col max-w-[70%] min-w-0 ${isOwnMessage ? "items-end" : "items-start"}`}
      >
        {/* Sender name — only shown on first message in group */}
        {!hideSenderName && !hideAvatar && (
          <div
            className={`flex items-baseline gap-2 mb-1.5 ${isOwnMessage ? "flex-row-reverse" : "flex-row"}`}
          >
            <span className="text-[13px] font-bold text-text-primary">
              {isOwnMessage ? "You" : senderName}
            </span>
          </div>
        )}

        {/* ── Bubble ─────────────────────────────────────────────────────── */}
        {/* NOTE: overflow-visible is critical — it lets ReactionTrigger's
                  absolute positioning show outside the bubble border without
                  being clipped. The popover itself uses a portal so it's
                  unaffected regardless. */}
        <div
          ref={bubbleRef}
          className={`
            relative
            px-4 py-2.5
            rounded-2xl
            text-[15px] leading-relaxed break-words
            shadow-subtle border
            ${isOwnMessage
              ? "bg-message-sent-bg text-message-sent-text border-message-sent-border rounded-tr-sm"
              : "bg-message-received-bg text-message-received-text border-message-received-border rounded-tl-sm shadow-premium"
            }
            ${hideAvatar ? (isOwnMessage ? "rounded-tr-2xl" : "rounded-tl-2xl") : ""}
                ${isPopoverOpen ? "z-50" : ""}
          `}
        >
          {renderMessageContent()}

          {/* ── Bubble footer: timestamp + status tick ───────────────────
               Always shown inside the bubble, bottom-right aligned.
               This is the ONLY place ticks render — no duplicates.        */}
          <div className={`flex items-center gap-1 mt-1 ${isOwnMessage ? "justify-end" : "justify-start"}`}>
            <span className="text-[10px] font-medium opacity-50 select-none leading-none">
              {formatTime(timestamp)}
            </span>
            {isOwnMessage && <MessageStatusTick status={derivedStatus} />}
          </div>

          {/* Reaction trigger */}
          {messageId && (
            <ReactionTrigger
              onClick={handleTriggerClick}
              isVisible={isHovered && !isPopoverOpen}
            />
          )}

          {/* Reaction popover — rendered via portal, anchored to bubbleRef */}
          {isPopoverOpen && (
            <ReactionPopover
              anchorRef={bubbleRef}
              messageId={messageId}
              onReaction={handleReaction}
              onPin={handlePin}
              onDelete={handleDelete}
              isOwn={isOwnMessage}
              isVisible={isPopoverOpen}
              onClose={closePopover}
            />
          )}
        </div>

        {/* ── Existing reaction chips ───────────────────────────────────── */}
        {safeReactions.length > 0 && (
          <div
            className={`flex flex-wrap gap-1 mt-1.5 ${isOwnMessage ? "justify-end" : "justify-start"}`}
          >
            {safeReactions.map((reaction, idx) => {
              const emojiChar = toEmojiChar(reaction.emoji);
              return (
                <button
                  key={`${emojiChar}-${idx}`}
                  type="button"
                  className="
                    inline-flex items-center gap-1.5
                    text-xs font-bold
                    bg-app-surface hover:bg-primary/10
                    rounded-full
                    px-2.5 py-1
                    cursor-pointer
                    transition-all
                    border border-border-subtle hover:border-primary/30
                    select-none
                    text-text-secondary hover:text-primary
                    shadow-subtle
                  "
                  onClick={(e) => {
                    e.stopPropagation();
                    onReaction?.(messageId, emojiChar);
                  }}
                  title={`${emojiChar} · ${reaction.count}`}
                >
                  <span className="scale-110">{emojiChar}</span>
                  {reaction.count > 1 && (
                    <span className="text-[10px] opacity-70">
                      {reaction.count}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
});

export default React.memo(MessageBubble);
